import { EDA } from "motw_core/Dreams/EDreamAttribute";
import * as React from "react";
import Dreams from "source/app/presentation/MainPanel/Dreams/Dreams";
import ChevronPanel from "source/app/presentation/Shared/ChevronPanel/ChevronPanel";
import { ShowCampaigns } from "../Filters/ShowCampaigns";
import { ShowDreamFilter } from "../Filters/ShowDreamFilter";
import { ShowFiguringOut } from "../Filters/ShowFiguringOut";
import { ShowReviews } from "../Filters/ShowReviews";
import * as styles from "../DreamFilterButtons.css";

export function DreamAdditionalFilters({ dreams }: { dreams: Dreams }) {
    return (
        <ChevronPanel id="additionalDreamFilters" label="More filters">
            <div className={styles.grid} style={{ opacity: 0.7 }}>
                <ShowDreamFilter dreams={dreams} attribute={EDA.important} />
                <ShowDreamFilter dreams={dreams} attribute={EDA.waypoint} />
                <ShowDreamFilter dreams={dreams} attribute={EDA.unclean} />
                <ShowDreamFilter dreams={dreams} attribute={EDA.in_progress} />
                <ShowDreamFilter dreams={dreams} attribute={EDA.buy} />
                <ShowDreamFilter dreams={dreams} attribute={EDA.reading} />
                <ShowDreamFilter dreams={dreams} attribute={EDA.prayer} />
                <ShowCampaigns dreams={dreams} />
                <ShowReviews dreams={dreams} />
                <ShowFiguringOut dreams={dreams} />
            </div>
        </ChevronPanel>
    );
}
